import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Notice } from "@/components/common/States";

const salin = async (teks) => {
  try {
    await navigator.clipboard.writeText(teks);
  } catch {
    // Clipboard API butuh HTTPS; metode lama tetap bekerja di peramban yang sama.
    const area = document.createElement("textarea");
    area.value = teks;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    document.execCommand("copy");
    document.body.removeChild(area);
  }
};

export function ResetLinkDialog({ hasil, onClose }) {
  if (!hasil) return null;
  const pesanWa = `Tautan reset kata sandi SIST untuk ${hasil.email}: ${hasil.link}`;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="reset-link-dialog">
        <DialogHeader><DialogTitle>Tautan reset kata sandi</DialogTitle></DialogHeader>
        <Notice tone={hasil.sent ? "ok" : "warn"} testId="reset-link-status">
          {hasil.sent
            ? `Tautan sudah dikirim ke email ${hasil.email}. Minta penerima memeriksa kotak masuk dan folder spam.`
            : `Email otomatis belum aktif, jadi tautan belum terkirim. Salin tautan di bawah lalu kirimkan ke ${hasil.email} lewat WhatsApp atau pesan lain.`}
        </Notice>
        <div className="rounded-lg border bg-muted p-3 font-mono text-xs break-all" data-testid="reset-link-value">
          {hasil.link}
        </div>
        <p className="text-xs text-muted-foreground">
          Tautan berlaku {hasil.minutes || 60} menit dan hanya dapat dipakai satu kali.
        </p>
        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="outline" asChild data-testid="reset-link-whatsapp">
            <a href={`https://wa.me/?text=${encodeURIComponent(pesanWa)}`} target="_blank" rel="noreferrer">
              <MessageCircle className="h-4 w-4 mr-1.5" /> WhatsApp
            </a>
          </Button>
          <Button onClick={async () => { await salin(hasil.link); toast.success("Tautan disalin."); }}
            data-testid="reset-link-copy">
            <Copy className="h-4 w-4 mr-1.5" /> Salin tautan
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
